import { FileTypeEnum } from '@generated/graphql';

export type UploadFileType = {
  type: FileTypeEnum;
  file: File;
};

export const generalAcceptFileTypes =
  'image/*,application/pdf,application/docx,application/doc';
